module.exports = __webpack_public_path__ + "img/giftNft.f39bde51.svg";